import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { PAY_VALUE_BY_NAME } from '../../../constants/payby';
import withLoadingView from '../../../decorators/withLoadingView';
import withTapPay from '../../../decorators/withTapPay';
import { updateApiCommonError } from '../../../redux/actions/apiCommonErrorActions';
import { postApplePayPrimeActions } from '../../../redux/actions/postApplePayPrimeActions';
import { makePaymentMethodByValue } from '../../../redux/selectors/checkoutMethodSelector';
import RetryApplePayBtn from './RetryApplePayBtn';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    applePayInfo: makePaymentMethodByValue(PAY_VALUE_BY_NAME.APPLE_PAY),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      postApplePayPrime: postApplePayPrimeActions.request,
      updateApiCommonError,
    },
    dispatch
  );
};

const enhance = compose(withTapPay, withLoadingView);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(enhance(RetryApplePayBtn));
